import { translate } from "@jsverse/transloco";

/** @param header The header string to translate */

export function translateHeader(header: string): string {
    if (!header) return '';

    const raw = header.toString().replace('*', '').trim().toLowerCase();

    const headerTranslationMap: Record<string, string> = {
        name: "name",
        description: "issues.description",
        user: "users.label",
        tension: "reusable.tension",
        trust: "reusable.trust",
        interest: "interest",
        influence: "reusable.influence",
        address: "custom-columns.address",
        city: "reusable.city",
        first_name: "reusable.first_name",
        last_name: "reusable.last_name",
        role: "users.access_field",
        department: "reusable.department",
        email: "custom-columns.email",
        personal_phone: "custom-columns.personal_phone",
        title: "custom-columns.title",
        location: "location",
        impact: "issues.impact",
        deadline: "time.deadline",
        date: "date",
        status: "decisions.status",
        feasibility: "decisions.feasibility",
        advice: "dashboard.advice",
        requirement_text_status: "custom-columns.requirement_text_status",
        complaint: "complaints.label",
        priority: "complaints.priority",
        close_date: "reusable.close_date",
        source: "dashboard.source",
        type: "dashboard.type",
        target_group: "reusable.target_group",
        start_date: "physical_context_label.start_date",
        end_date: "end_date",
        permit: "permits.label",
        authority: "permits.authority",
        "bevoegd gezag": "permits.authority",
        "id  authority": "permits.authority_id",
        "id authority": "permits.authority_id",
        "bevoegd gezag id": "permits.authority_id",
        requirements: "permits.requirements",
        indieningsvereisten: "permits.requirements",
        requester: "custom-columns.requester",
        cluster: "custom-columns.cluster",
        validity: "custom-columns.validity"
    };

    const translationKey = headerTranslationMap[raw];

    const translated = translationKey
        ? translate(translationKey)
        : header.toString().replace('*', '').trim();

    // Preserve required mark (*)
    return header.toString().includes('*')
        ? capitalizeFirstLetter(`${translated}*`)
        : capitalizeFirstLetter(translated);
}

function capitalizeFirstLetter(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getSheetTranslationKey(sheetName: string): string {
    if (!sheetName) return '';
    const normalizedName = sheetName.toLowerCase().trim();
    const sheetMap: { [key: string]: string } = {
      'stakeholders': 'stakeholders.labels',
      'contactpersons': 'menu.contactpersons',
      'contact_persons': 'menu.contactpersons',
      'contactpersonen': 'menu.contactpersons',
      'issues': 'menu.issues',
      'requirements': 'menu.customer_requirements',
      'klanteisen': 'menu.customer_requirements',
      'contactmoments': 'menu.contactmoments',
      'contact_moments': 'menu.contactmoments',
      'contactmomenten': 'menu.contactmoments',
      'complaints': 'menu.complaints',
      'meldingen': 'menu.complaints',
      'contents': 'contents.labels',
      'content': 'contents.labels',
      'middelen': 'contents.labels',
      'activiteiten': 'reusable.activities',
      'activities': 'reusable.activities',
      'permits': 'permits.labels',
      'vergunningen': 'permits.labels',
    };
    return sheetMap[normalizedName] || sheetName;
  }